import { createReducer, createAction } from '@reduxjs/toolkit'

export interface ChannelActivation {
  id: number
  login: string
  mobile_seller_id: string | null
  max_images: number | null
}

export interface Channel {
  id: number
  name: string
  uniq_name: string
  logo_url: string | null
  activation: ChannelActivation | null
}

export interface IntegrationsReducer {
  channels: Channel[]
  loading: boolean
  error: boolean
}

const initialState: IntegrationsReducer = {
  channels: [],
  loading: false,
  error: false
}

export const FETCH_CHANNELS = createAction('integrations_reducer/fetch_channels')
export const FETCH_CHANNELS_SUCCESS = createAction<{ channels: Channel[] }>(
  'integrations_reducer/fetch_channels_success'
)
export const FETCH_CHANNELS_FAILURE = createAction('integrations_reducer/fetch_channels_failure')

export const CREATE_CHANNEL_ACTIVATION = createAction<{
  channel_id: number
  login: string
  password: string
}>('integrations_reducer/create_channel_activation')
export const CREATE_CHANNEL_ACTIVATION_SUCCESS = createAction('integrations_reducer/create_channel_activation_success')
export const CREATE_CHANNEL_ACTIVATION_FAILURE = createAction('integrations_reducer/create_channel_activation_failure')

export const SYNC_CHANNEL_ACTIVATION = createAction<{ id: number }>('integrations_reducer/sync_channel_activation')
export const SYNC_CHANNEL_ACTIVATION_SUCCESS = createAction('integrations_reducer/sync_channel_activation_success')
export const SYNC_CHANNEL_ACTIVATION_FAILURE = createAction('integrations_reducer/sync_channel_activation_failure')

export const DELETE_CHANNEL_ACTIVATION = createAction<{ id: number }>('integrations_reducer/delete_channel_activation')
export const DELETE_CHANNEL_ACTIVATION_SUCCESS = createAction('integrations_reducer/delete_channel_activation_success')
export const DELETE_CHANNEL_ACTIVATION_FAILURE = createAction('integrations_reducer/delete_channel_activation_failure')

export const integrationsReducer = createReducer(initialState, (builder) => {
  builder.addCase(FETCH_CHANNELS, (state) => {
    return { ...state, loading: true, error: false }
  })
  builder.addCase(FETCH_CHANNELS_SUCCESS, (state, action) => {
    return { ...state, channels: action.payload.channels, loading: false, error: false }
  })
  builder.addCase(FETCH_CHANNELS_FAILURE, (state) => {
    return { ...state, loading: false, error: true }
  })
  builder.addCase(CREATE_CHANNEL_ACTIVATION_FAILURE, (state) => {
    return { ...state, error: true }
  })
  builder.addCase(SYNC_CHANNEL_ACTIVATION_FAILURE, (state) => {
    return { ...state, error: true }
  })
  builder.addCase(DELETE_CHANNEL_ACTIVATION_FAILURE, (state) => {
    return { ...state, error: true }
  })
})
